import hamburger from './HamburgerMenu.svg'
import house from './House.png'
import skyline from './Skyline.png'
import React from 'react';

const styles = {
  housingContainer: {
    alignItems: 'stretch',
    flex: 1,
    backgroundColor: 'white',
    marginLeft: '25%',
    marginRight: '25%'
  },
  housingView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: 20
  },
  menuIcon: {
    width: '80px',
    height: '80px',
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 20
  },
  skylineImage: {
    height: 'auto',
    width: '80%',
    marginTop: '100px'
  },
  headline: {
    textShadow: '3px 3px 3px #ccc'
  }
}

function HousingJustice(props) {
  return (
    <div style={styles.housingContainer}>
      <div style={styles.housingView}>
        <a href='/menu'>
          <img src={hamburger} style={styles.menuIcon} />
        </a>
        <img src={skyline} style={styles.skylineImage} />
        <h1 style={styles.headline}>
          Housing Justice Information
        </h1>
        <h3>
          Housing is a human right!
        </h3>
        <p>
          Pittsburgh City Council
          <a
            href="https://triblive.com/local/city-council-resolution-declares-housing-a-human-right-in-pittsburgh/"
            style={{ marginRight: 2, marginLeft: 2}}
          >
            proclaimed housing a human right
          </a>
          last year, but our representatives have not done what is needed to ensure that this right is met for
          everyone in our city. Pittsburgh DSA is working to build collective power to help support
          our neighbors and pressure our representatives to provide safe, dignified, permanent housing
          for everyone in need, regardless of their ability to pay.
        </p>
        <p>
          We all deserve home!
        </p>
        <h2>
          Actions
        </h2>
        <h3>
          Tenants Right to Counsel
        </h3>
        <p>
          There are few experiences more frightening and stressful than being threatened
          with the loss of your home. Evictions impact families in many ways, from the
          disruption of having to find somewhere new to live; interruptions to work, school,
          and healthcare; the stress and expense of moving; loss of deposit payments; damage
          to your credit; and the terrifying possibility of homelessness. Landlords hold a lot
          of power: they can choose to pursue legal action to evict, raise the rent, refuse to
          do needed maintenance and repairs. When it comes to eviction cases, landlords often have
          the upper hand because they have experience with the court system and can afford to hire
          legal representation to argue their case. Most tenants facing eviction cannot afford attorneys.
          It is unsurprising that the vast majority of eviction cases are won by landlords. Many struggling
          tenants “self-evict” when threatened with eviction, leaving their homes out of fear of legal action.
        </p>
        <h3>
          Did you know that there is no right to legal representation for people threatened with eviction?
        </h3>
        <p>
          It seems obvious to us, and to most regular people, that this should be a right that all people have,
          even if they cannot afford to pay. If you were faced with one of the most disruptive, frightening threats
          a person can endure, wouldn’t you want an expert by your side? Wouldn’t you want that for anyone in this
          awful position?
        </p>
        <p>
          Our neighbors across the state in Philadelphia have fought for and won the legal right to counsel
          for tenants threatened with eviction, in addition to many other cities, including New York, San Francisco,
          Newark, Cleveland, Boulder, and Baltimore. It is past time for Pittsburgh to join these other cities in
          protecting our most vulnerable neighbors and ensuring fair treatment for all, not just for those that can
          afford it.
        </p>
        <p>
          Pittsburgh DSA calls upon our representatives on Pittsburgh City Council and Allegheny County Council to
          pass legislation ensuring tenants’ right to counsel. To get involved and lend your voice to this demand, s
          ign up <a href="/contact-us">here</a> and we’ll be in touch about how you can help!
        </p>
        <h3>
          Tenant Organizing
        </h3>
        <p>
          Unions are powerful, and they aren’t just for workers!
        </p>
        <p>
          Tenants' unions are renter-led organizations that advocate for tenant rights, build renter power,
          and push for renter-friendly policy change. A well-organized tenants' union can have the power to
          self-advocate regarding a variety of grievances. Organizing tactics can include forcing direct
          negotiations with building managers, filing collective complaints to city or state agencies,
          or even calling for a rent strike.
        </p>
        <p>
          Landlords don’t work or contribute to society. Instead, they horde property, taking more than
          they need and creating scarcity for regular people who are unable to purchase homes and driving
          up the price for everyone. Tenant Unions create connections among neighbors, shifting the balance
          of power away from landlords and back toward regular people who need homes (that’s all of us!)
        </p>
        <p>
          To learn more about tenant unions and how to get started in tenant organizing, check out
          <a href="https://pittsburghunionofregionalrenters.wordpress.com/">
            Pittsburgh Union of Regional Renters.
          </a>
        </p>
        <p>
          To support these campaigns and other projects for housing justice in Western PA, sign up <a href="/contact-us">here</a> to
          get involved with Pittsburgh DSA’s Housing committee
        </p>
        <h3>
          Resources
        </h3>
        <p>
          If you or someone you know is facing housing insecurity, you are not alone! Check out the
          resources here, or get in touch with us <a href="/contact-us">here</a> and we’ll do our best to help!
        </p>
        <br />
        <a href="./SlumlordZine.pdf">
          Pittsburgh DSA Slumlord Info
        </a>
        <br />
        <br />
        <a href="https://ulpgh.org/programs/housing/rental-assistance/">
          Information about rental assistance
        </a>
        <br />
        <br />
        <p>
          <a href="https://nlsa.us/request-legal-help/" style={{ marginRight: 2 }}>
            Neighborhood Legal Services
          </a>
          can provide tenant/landlord mediation and advice
        </p>
        <br />
        <br />
        <a href="https://hacp.org/programs-services/assistance/emergency-housing-services/">
          Emergency Housing Services from Pittsburgh Housing Authority
        </a>
        <br />
        <br />
        <a href="https://www.alleghenycounty.us/human-services/programs-services/basic-needs/housing-and-homeless.aspx">
          Housing Resources from Allegheny County Department of Human Services
        </a>
      </div>
    </div>
  )
}

export default HousingJustice;
